import { useState } from 'react'
import styled from '@emotion/styled'

import { QUICK_LOOKUP_TYPES } from 'components/lab/constants/quickLookup'
import type { QuickLookupType } from 'components/lab/constants/quickLookup'

const LOOKUP_TYPES = Object.keys(QUICK_LOOKUP_TYPES) as QuickLookupType[]
const ACCENT = '#66a3ee'

const Card = styled.div`
  margin: 0.5rem 12px 1rem;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
`

const Row = styled.label`
  display: grid;
  grid-template-columns: 70px 1fr auto;
  align-items: center;
  height: 38px;
  margin: 0 12px;
  cursor: text;

  & + & {
    border-top: 1px solid rgba(255, 255, 255, 0.14);
  }
`

const Label = styled.span`
  color: #e0e2e5;
  font-weight: 400;
  white-space: nowrap;
`

const Input = styled.input`
  width: 100%;
  min-width: 0;
  height: 26px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  outline: none;

  &::placeholder {
    color: #9da7b7;
  }
`

const GoButton = styled.button`
  margin-left: 10px;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${ACCENT};
  font-size: 1.1rem;
  line-height: 1;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    color: #8fbcf4;
  }
`

const QuickLookup = () => {
  const [lookupIds, setLookupIds] = useState<Record<QuickLookupType, string>>({
    order: '',
    account: '',
  })

  const openLookup = (type: QuickLookupType) => {
    if (!lookupIds[type]) return
    window.location.href = QUICK_LOOKUP_TYPES[type].getPath(lookupIds[type])
  }

  return (
    <Card>
      {LOOKUP_TYPES.map((type) => (
        <Row key={type}>
          <Label>{QUICK_LOOKUP_TYPES[type].label}</Label>
          <Input
            inputMode="numeric"
            autoComplete="off"
            placeholder="Enter ID"
            value={lookupIds[type]}
            onChange={(e) =>
              setLookupIds((ids) => ({ ...ids, [type]: e.target.value.replace(/\D/g, '') }))
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter') openLookup(type)
            }}
          />
          <GoButton
            type="button"
            aria-label={`Open ${QUICK_LOOKUP_TYPES[type].label}`}
            onClick={() => openLookup(type)}>
            <i className="far fa-arrow-right" />
          </GoButton>
        </Row>
      ))}
    </Card>
  )
}

export default QuickLookup
